import React from 'react';
import * as yup from 'yup';
import FieldArrayFormSection from '../../../../common/hookFormComponents/FieldArrayFormSection';

const fields = [
  {
    colSpan: 1,
    name: 'materialName',
    type: 'text',
    label: 'Material Name',
  },
  {
    colSpan: 1,
    name: 'materialQuantity',
    type: 'text',
    label: 'Requirement (In Tons)',
  },
];

export const defaultWeavOtherRawMatFieldValues = fields.reduce(
  (obj, item) => [{ ...obj, [item['name']]: '' }],
  [{}],
);

export const WeavOtherRawMatFieldsValidation = {
  weavOtherRawMaterials: yup.array().of(
    yup.object().shape({
      [fields[0].name]: yup.string().label(fields[0].label),
      [fields[1].name]: yup.string().label(fields[1].label),
    }),
  ),
};

const WeavOtherRawMatSection = (props) => {
  return (
    <FieldArrayFormSection
      sectionColumn={3}
      sectionName="Other Raw Materials"
      name="weavOtherRawMaterials"
      formFields={fields}
      {...props}
    />
  );
};

export default WeavOtherRawMatSection;
